import { render } from "./AcceptedSDCView.vue?vue&type=template&id=fd66eeea&scoped=true"
const script = {}

import "./AcceptedSDCView.vue?vue&type=style&index=0&id=fd66eeea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd66eeea"]])

export default __exports__